import { useDispatch } from 'react-redux';
import Ajv from 'ajv';

import { actionUrl } from 'config/static-content';
import { sendJourneyDataThunk } from 'state/journey-data/journey-data-thunks';
import { useJourneDataPayload } from 'hooks/useJourneyDataPayload';
import { setError as setQuoteError } from 'state/quote/quote-slice';
import { SchemaValidationError } from 'errors/SchemaValidationError';
import { useReferFriend } from './useReferFriend';
import { useNavigation } from 'hooks/useNavigation';

import journeyDataPayloadSchema from 'api/schemas/journey-data-payload-schema.json';

export const useGetSapQuote = () => {
  const dispatch = useDispatch();
  const journeyDataPayload = useJourneDataPayload();
  const { rafToken } = useReferFriend();
  const { next, eventTypes } = useNavigation();

  const ajv = new Ajv({ strict: false });
  const isValidJourneyData = ajv.validate(
    journeyDataPayloadSchema,
    journeyDataPayload
  );

  if (!isValidJourneyData) {
    return async () => {
      const error = new SchemaValidationError({
        title: 'An error occurred',
        message: `We cannot get a quote at this time. Please contact ${actionUrl.support}`,
        payload: journeyDataPayload,
        schema: journeyDataPayloadSchema,
        ajvErrors: ajv.errors
      });

      return dispatch(setQuoteError([error.toJson()]));
    };
  }

  return async () => {
    return await dispatch(sendJourneyDataThunk(journeyDataPayload)).then(
      (response) => {
        next({
          eventType: eventTypes.NEXT,
          queryParams: {
            dataID: response.id,
            ...(rafToken ? { bp_e: rafToken } : {})
          }
        });
      }
    );
  };
};
